import { WidgetType } from '@/shared/components/Mosaic'

/**
 * Default widget names used in the widget window toolbar
 */
export const defaultWidgetNames: Record<WidgetType, string> = {
  Inbox: 'Inbox',
  PlanningShiftTable: 'Planning Shift',
  ScenarioSummaryTable: 'Scenario Summary',
  RunsheetSummaryTable: 'Runsheet Summary',
  ScenarioUnassignedOrders: 'Unassigned Orders',
  RunsheetShiftTable: 'Runsheet Shift',
  RunsheetUnassignedOrders: 'Unassigned Orders',
  Map: 'Map',
  Violations: 'Violations',
  Geocode: 'Geocode',
  GanttChart: 'Gantt Chart',
  A2BRoute: 'A2BRoute',
  Solver: 'Solver',
  RunsheetBreaks: 'Breaks',
}
